// extracted by mini-css-extract-plugin
export default {"title":"index-module--title--4a6a3","titleIcon":"index-module--title-icon--bcdfb","closed":"index-module--closed--11bc8"};